import styled from 'styled-components';

export const StyledAddEditLanguage = styled.div`
  ${({ theme }) => `
    .Mui-checked {
      color: ${theme.uptimeColors.mainTheme.primary} !important;
    }
  `}
`;